const initialState = {
    cast :[],
    movie : [],
    selectedMovie : [],
}

const movieReducer = (state=initialState, {type, payload}) =>{
    switch (type){
        case 'SETCHARACTER' :
            return{
                ...state,
                cast : payload
            }
        case 'SETMOVIE' :
            return{
                ...state,
                movie : state.movie.concat(payload)
            }
        case 'SELECTEDMOVIE' :
            return{
                ...state,
                selectedMovie : state.selectedMovie.concat(payload)
            }
        case 'EMPTYSELECTEDMOVIE' :
            return{
                ...state,
                selectedMovie : []
            }
        case 'SETMOVIE' :
            return{
                ...state,
                status : payload
            }
            
        default :
            return state
    }
}

export default movieReducer